import { Injectable } from "@angular/core";
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { IOrderBasdata } from "../models/justeraLeveransplanModel";

@Injectable({
    providedIn: "root"
})
export class JusteraLeveransplanFilterService {

    searchParams: any;

    readonly areaType = {
        marknadsomrade: "MO",
        resultatsomrade: "RO",
        produktionsomrade: "PO"
    };

    readonly treeTypes = {
        handelssortiment: "Handelssortiment",
        produktionsomrade: "Produktionsområde"
    };

    private treeType;

    private readonly selectedLevel = {
        none: "none",
        partial: "partial",
        all: "all"
    };

    private readonly handelssortimentType = {
        group: "HG",
        handelssortiment: "HS"
    };

    setFilter(basdata: IOrderBasdata, searchParams: any, treeType: string) {
        this.treeType = treeType;
        this.searchParams = searchParams;

        if (treeType === this.treeTypes.handelssortiment) {
            basdata.handelssortiment = [];
            basdata.handelssortimentsgrupper.forEach(data => {
                basdata.handelssortiment.push(this.createTreeSelectionNode(data));
            });
            this.setPartialSelected(basdata.handelssortiment);
        } else {
            basdata.omraden = [];
            basdata.marknadsomraden.forEach(data => {
                basdata.omraden.push(this.createTreeSelectionNode(data));
            });
            this.setPartialSelected(basdata.omraden);
        }

        return basdata;
    }

    getSelectedHandelssortiment(handelssortimentsgrupper: any) {
        const data = [];
        handelssortimentsgrupper.forEach((hsg: any) => {
            if (hsg.selected) {
                data.push( {
                    typ: this.handelssortimentType.group,
                    id: hsg.value
                });
            }

            if (hsg.selected || hsg.partialSelected) {
                hsg.children.forEach((hs: any) => {
                    if (hs.selected) {
                        data.push( {
                            typ: this.handelssortimentType.handelssortiment,
                            id: hs.value
                        });
                    }
                });
            }
        });

        return data;
    }

    getSelectedAreas(omraden: any, omradeTyp: string): any[] {
        const selectedAreas = [];
        omraden.forEach((omrade: any) => {
            if (omrade.selected) {
                selectedAreas.push( {
                    typ: omradeTyp,
                    id: omrade.value
                });
            }
            if  ((omrade.selected || omrade.partialSelected) && omradeTyp !== this.areaType.produktionsomrade) {
                const childType = omradeTyp === this.areaType.marknadsomrade ?
                    this.areaType.resultatsomrade :
                    this.areaType.produktionsomrade;
                const children = this.getSelectedAreas(omrade.children, childType);
                children.forEach((child: any) => {
                    selectedAreas.push(child);
                });
            }
        });
        return selectedAreas;
    }

    private createTreeSelectionNode(node: any) {
        let children: SelectionItem[] = null;
        if (!this.isNullOrEmpty(node.children)) {
            children = children === null ? [] : children;
            node.children.forEach((data: any) => {
                children.push(this.createTreeSelectionNode(data));
            });

        }

        return {
            value: node.id,
            text: node.namn,
            selected: this.setNodeSelection(node),
            partialSelected: false,
            children: children
        } as SelectionItem;
    }

    private setNodeSelection(node: any): boolean {
        let res = false;
        if (this.treeType === this.treeTypes.handelssortiment) {
            this.searchParams.handelssortimentsgrupper.forEach((grupp: any) => {
                if (grupp.id === node.id &&
                    (grupp.typ === this.handelssortimentType.group && !this.isNullOrEmpty(node.children) ||
                    grupp.typ === this.handelssortimentType.handelssortiment && this.isNullOrEmpty(node.children))) {
                    res = true;
                }
            });
        } else if (this.treeType === this.treeTypes.produktionsomrade) {
            this.searchParams.omraden.forEach((omrade: any) => {
                if (omrade.id === node.id && this.areSameAreaTypes(omrade, node)) {
                    res = true;
                }
            });
        }
        return res;
    }

    private setPartialSelected(array: any): any {
        array.forEach((a: any) => {
            if (!this.isNullOrEmpty(a.children)) {
                const res = this.setSelectedChildren(a.children);
                if (res === this.selectedLevel.all) {
                    a.selected = true;
                } else if (res ===  this.selectedLevel.partial) {
                    a.partialSelected = true;
                }
            }
        });

        return array;
    }

    private setSelectedChildren(array: any): string {
        let numberOfSelected = 0;
        let isPartial = false;
        array.forEach((a: any) => {
            if (!a.selected && !this.isNullOrEmpty(a.children)) {
                const res = this.setSelectedChildren(a.children);
                if (res === this.selectedLevel.all) {
                    a.selected = true;
                } else if (res === this.selectedLevel.partial) {
                    a.partialSelected = true;
                    isPartial = true;
                }
            } else if (a.selected === true) {
                numberOfSelected++;
            }
        });
        if (numberOfSelected === 0 && !isPartial) {
            return this.selectedLevel.none;
        } else if (numberOfSelected === array.length) {
            return this.selectedLevel.all;
        } else if (isPartial || (numberOfSelected < array.length && numberOfSelected > 0)) {
            return this.selectedLevel.partial;
        }

        return this.selectedLevel.none;
    }

    private areSameAreaTypes(omrade: any, node: any) {
        const marknadsomradeId = "marknadsomradeId";
        const resultatsomradeId = "resultatomradeId";

        if (omrade.typ === this.areaType.produktionsomrade) {
            return node[resultatsomradeId] !== undefined;
        } else if (omrade.typ === this.areaType.resultatsomrade) {
            return node[marknadsomradeId] !== undefined;
        } else {
            return node[marknadsomradeId] === undefined &&
                    node[resultatsomradeId] === undefined;
        }
    }

    private isNullOrEmpty(obj: any): boolean {
        return obj === undefined || obj === null;
    }
}
